<template>
  <div>
    <div>{{ text }}</div>
    <loadingIndicator> </loadingIndicator>

  </div>
  
</template>

<script>
import helper from "@/helpers/signInHelper";
import Utils from '../../utils/utils';
import  loadingIndicator  from "./loadingIndicator";
export default {
  components: { loadingIndicator },
  data() {
    return {
      text: null,
    };
  },
  async mounted() {
    this.$http.get("/api/authentication/sign-in/callback").then(
      (a) => {
        helper.signIn(a.body.token);
      },
      (a) => {
        let { isNotRegistered, isEmailConfirmed, message } = a.body;
        if (isNotRegistered) return this.$router.push("/sign-up");
        if (isEmailConfirmed === false) {
          alert(message);
          return this.$router.push("/login?email-confirm");
        }
      }
    );
  },
};
</script>

<style scoped>

</style>
